var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticStyle: {
      "margin-top": "-15px"
    }
  }, [_c('a-tabs', {
    staticClass: "mb-10",
    attrs: {
      "activeKey": _vm.activeTab
    },
    on: {
      "change": _vm.handleChange
    }
  }, _vm._l(_vm.tabList, function (item) {
    return _c('a-tab-pane', {
      key: item.value,
      attrs: {
        "id": 'wrapper_list_' + item.value,
        "tab": item.text
      }
    });
  }), 1), _c(_vm.activeTab, {
    ref: "componentRef",
    tag: "component",
    attrs: {
      "fbu-analyse-tab-pane": _vm.$util.getEnumTextByValue(_vm.tabList, _vm.activeTab)
    },
    on: {
      "switchTab": _vm.handleSwitchTab
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };